import LocationDateTimeForm from '../../components/LocationDateTimeForm'
import NotificationPerformance from './components/NotificationPerformance'
import NotificationStoreRanking from './components/NotificationStoreRanking'
import UserCrossVisit from './components/UserCrossVisit'
import UserVisitFrequency from './components/UserVisitFrequency'
import UserVisitPerformanceBasic from './components/UserVisitPerformanceBasic'
import UserVisitSiteRankingBasic from './components/UserVisitSiteRankingBasic'
import UserWeeklyTrafficPatterns from './components/UserWeeklyTrafficPatterns'

function UserVisitAnalysisBasic() {
  return (
    <>
      <LocationDateTimeForm />
      <div className='grow grid xl:grid-cols-3 grid-cols-2 gap-4'>
        <UserVisitPerformanceBasic className='col-span-2' />
        <UserWeeklyTrafficPatterns className='col-span-1 row-span-2' />
        <UserVisitFrequency className='col-span-1' />
        <UserCrossVisit className='col-span-1' />
        <UserVisitSiteRankingBasic className='col-span-3' />
        <NotificationPerformance className='col-span-3' />
        <NotificationStoreRanking className='col-span-3' />
      </div>
    </>
  )
}

export default UserVisitAnalysisBasic
